// modules
import AlertArea from "./prototype/ui/AlertArea.js";
import AttachmentsEditorArea from "./prototype/ui/AttachmentsEditorArea.js";
import BottomArea from "./prototype/ui/BottomArea.js";
import AssistantArea from "./prototype/ui/AssistantArea.js";
import ConfirmationArea from "./prototype/ui/ConfirmationArea.js";
import FlashMessageArea from "./prototype/ui/FlashMessageArea.js";
import GraphicsArea from "./prototype/ui/GraphicsArea.js";
import GraphicsUpdateArea from "./prototype/ui/GraphicsUpdateArea.js";
import InputCoordinatesArea from "./prototype/ui/InputCoordinatesArea.js";
import InputTextArea from "./prototype/ui/InputTextArea.js";
import InputAdminPasswordArea from "./prototype/ui/InputAdminPasswordArea.js";
import LoadingArea from "./prototype/ui/LoadingArea.js";
import LoadingMediaArea from "./prototype/ui/LoadingMediaArea.js";
import LogsArea from "./prototype/ui/LogsArea.js";
import DesktopSettingsArea from "./prototype/ui/DesktopSettingsArea.js";
import ResourcesArea from "./prototype/ui/ResourcesArea.js";
import ResourcesEditorArea from "./prototype/ui/ResourcesEditorArea.js";
import RoomArea from "./prototype/ui/RoomArea.js";
import RoomListArea from "./prototype/ui/RoomListArea.js";
import RoomShareArea from "./prototype/ui/RoomShareArea.js";
import StatusArea from "./prototype/ui/StatusArea.js";
import ToastArea from "./prototype/ui/ToastArea.js";
import UserArea from "./prototype/ui/UserArea.js";
import BackgroundImageSettingsArea from "./prototype/ui/BackgroundImageSettingsArea.js";
import GridSettingsArea from "./prototype/ui/GridSettingsArea.js";
import UISettingsArea from "./prototype/ui/UISettingsArea.js";
import MapSettingsArea from "./prototype/ui/MapSettingsArea.js";
import NotesUpdateArea from "./prototype/ui/NotesUpdateArea.js";
import UserListArea from "./prototype/ui/UserListArea.js";
import VoronoiArea from "./prototype/ui/VoronoiArea.js";

// app components
import "./prototype/Medias.js";
import "./prototype/Scene.js";
import "./prototype/Tool.js";
import "./prototype/View.js";
import "./prototype/SVG.js";
import "./prototype/Users.js";
import "./prototype/Commissioning.js";
import "./prototype/Configuration.js";
import "./prototype/Storage.js";
import "./prototype/Resources.js";
import "./prototype/Geolocation.js";
import "./prototype/GalleryViewer.js";
import "./prototype/Internationalization.js";

// routes
import f_mtac_routes_index from "./route/index.js";
import f_mtac_routes_superadmin from "./route/superadmin.js";
import f_mtac_routes_admin from "./route/admin.js";
import f_mtac_routes_landing from "./route/landing.js";

import Router from "router";

new Router({
    f_mtac_routes_index,
    f_mtac_routes_superadmin,
    f_mtac_routes_admin,
    f_mtac_routes_landing
}).loadEvents();

export const ui = {
    AlertArea,
    AttachmentsEditorArea,
    BottomArea,
    AssistantArea,
    ConfirmationArea,
    FlashMessageArea,
    GraphicsArea,
    GraphicsUpdateArea,
    InputCoordinatesArea,
    InputTextArea,
    LoadingArea,
    LoadingMediaArea,
    LogsArea,
    DesktopSettingsArea,
    BackgroundImageSettingsArea,
    GridSettingsArea,
    UISettingsArea,
    MapSettingsArea,
    ResourcesArea,
    ResourcesEditorArea,
    RoomArea,
    RoomListArea,
    RoomShareArea,
    StatusArea,
    ToastArea,
    UserArea,
    InputAdminPasswordArea,
    NotesUpdateArea,
    UserListArea,
    VoronoiArea
};

export {default as global} from "./prototype/global.js";
